<div role="tabpanel" class="tab-pane checklist portfolio-tab-pane {{#if first}}active{{/if}}" id="{{key}}_pane">
  {{#if grouped_by_module}}
    <div role="tabpanel">
      <ul class="tabs checklist-tabs" role="tablist">
        {{#each modules}}
          <li role="presentation" class="tab checklist-tab {{#if @first}}active{{/if}}">
            <a href="#{{key}}_pane" id="{{key}}" role="tab" data-toggle="tab">{{t title}}</a>
          </li>
        {{/each}}
      </ul>
      <div class="tab-content checklist-tab-content checklist-items">
      </div>
    </div>
  {{else}}
    <div class="checklist-items"></div>
  {{/if}}
</div>
